import { render, staticRenderFns } from "./KPanelSubHeader.vue?vue&type=template&id=a671f504&"
import script from "./KPanelSubHeader.vue?vue&type=script&lang=js&"
export * from "./KPanelSubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports